import { FCX } from "@datassential/platform-ui-lib";
import useCategoryProfileHighlights from "@apiHooks/useCategoryProfileHighlights";
import { ID } from "@models";
import InsightsSummaryCard from "@components/InsightsSummaryCard/InsightsSummaryCard";

interface Props {
    bullets: string[];
    isLoading: boolean;
}

export const useHighlightsSectionData = (categoryId: ID) => {
    const { data, isLoading } = useCategoryProfileHighlights(categoryId);
    // Stay mounted while loading so the card can show its skeleton.
    return { hasData: isLoading || data.length > 0, isLoading, data };
};

const CategoryProfileHighlights: FCX<Props> = ({ bullets, isLoading }) => (
    <InsightsSummaryCard
        className="CategoryProfileHighlights"
        testId="blockCategoryProfileHighlights"
        title="Category Insights"
        bullets={bullets}
        isLoading={isLoading}
    />
);

export default CategoryProfileHighlights;
